import React from 'react';
import history from './history';
import {
    questionFollow,
    questionUnfollow,
    // blockUnblockUser,
    report,
    // reportReasonsFetch,
    questionHide,
    questionDelete,
    replyDelete,
    replyCommentDelete,
    memoryCommentDelete,
    memoryDelete,
    addSystemMessage
} from '../actions/index';
import {gtmSend} from '../helpers';
// import {Icon} from '../components/Common/Icon';
import ReportReasonsComponent from '../components/Misc/ReportReasons';
import BlockUnblockUser from '../components/Common/BlockUnblockUser';
// import cx from '../styles';

const mapAction = (type, action, params, dispatch) => {
    switch(action.type) {
        case 'follow':
            if(type == 'question') {
                action['handler'] = () => {
                    gtmSend('click question follow', 'card-main', 'click:follow', params.id);
                    dispatch(questionFollow(params.id, params.inFeed))
                    .then(() => dispatch(addSystemMessage({id: Math.random(), message: params.t('followed'), level: 'success'})));
                }
            }
        break;
        case 'unfollow':
            if(type == 'question') {
                action['handler'] = () => {
                    gtmSend('click question unfollow', 'card-main', 'click:unfollow', params.id);
                    dispatch(questionUnfollow(params.id, params.inFeed))
                    .then(()=>dispatch(addSystemMessage({id: Math.random(), message: params.t('unfollowed'), level: 'success'})));
                }
            }
        break;
        case 'report':
            const onReportSubmit = (e) => {
                const entityId = params.id;
                const reasonId = e.target.reason && e.target.reason.value;
                const comment = e.target.comment.value;
                dispatch(report(type, entityId, reasonId, comment));
            }
            action['title'] = <ReportReasonsComponent title={'report'} onSubmit={onReportSubmit} type={type} position={params.position} id={params['id']} topic={params['topic']} cardName={params['cardName']} authorId={params['authorId']}/>;
            action['handler'] = ()=>{};
        break;
        case 'report_user':
            const onReportUserSubmit = (e) => {
                const entityId = params.authorId;
                const reasonId = e.target.reason.value;
                const comment = e.target.comment.value;
                const entityReasonId = params.id;
                dispatch(report(type+'_user', entityId, reasonId, comment, entityReasonId));
            }
            const userType = type === 'profile'? 'user' : type+'_user'
            action['title'] = <ReportReasonsComponent title={'report_user'} onSubmit={onReportUserSubmit} type={userType} position={params.position} id={params['id']} topic={params['topic']} cardName={params['cardName']} authorId={params['authorId']}/>;
            action['handler'] = ()=>{};
        break;
        case 'user_blocks_user':
            const userId = params.authorId;
            const userName = params.authorName;
            const entityId = userName === 'Anonymous'? params.id : userId;
            const entityType = userName === 'Anonymous'? (action.title && action.title.props && action.title.props.entityType? action.title.props.entityType : type) : 'profile';
            action['title'] = <BlockUnblockUser entityType={entityType} entityId={entityId} status={1} userId={userId} userName={userName} blockUser={true} postCard={true} type={type} subType={params.subType} detailPage={params.detailPage} id={params['id']} topic={params['topic']} postId={params['postId']} cardName={params['cardName']}/>;
            action['handler'] = ()=>{};
        break;
        case 'user_unblocks_user':
            const user_id = params.authorId;
            const user_name = params.authorName;
            const entity_id = user_id;
            const entity_type = 'profile';
            action['title'] = <BlockUnblockUser entityType={entity_type} entityId={entity_id} status={0} userId={user_id} userName={user_name} blockUser={false} postCard={true} type={type} subType={params.subType} detailPage={params.detailPage} id={params['id']} topic={params['topic']} postId={params['postId']} cardName={params['cardName']}/>;
            action['handler'] = ()=>{};
        break;
        case 'hide':
            if(type == 'question') {
                action['handler'] = () => dispatch(questionHide(params.hideUrl, params.id, params.inFeed))
                .then(()=> !params.inFeed && history.goBack());
            }
        break;
        case 'skip':
            if(type == 'question') {
                action['handler'] = () => dispatch(questionHide(params.hideUrl, params.id, params.inFeed))
                .then(()=> !params.inFeed && history.goBack());
            }
        break;
        case 'edit':
            if(type == 'question') {
                action['handler'] = () =>  params.inFeed ? params.elemRef.goToSingleView({shouldOpenQEditDialog: true}) : params.elemRef.openEditModal()
            }
            if(type == 'answer') {
                action['handler'] = () =>  params.inFeed ? params.elemRef.goToSingleView({shouldOpenREditDialog: true, replyId: params.id}) : params.elemRef.openEditReplyModal()
            }
            if(type == 'booth') {
                action['handler'] = () =>  params.inFeed ? params.elemRef.goToSingleView({shouldOpenBEditDialog: true}) : params.elemRef.openEditCaptionModal()
            }
        break;
        case 'remove':
            if(type == 'question') {
                action['handler'] = () => dispatch(
                    addSystemMessage(
                        constructDeleteConfirmation(params, ()=>dispatch(questionDelete(params.id, params.inFeed))
                            .then(() => !params.inFeed && history.push({pathname: '/feed'})))
                    )
                );
            }
            if(type == 'answer') {
                action['handler'] = () => dispatch(
                    addSystemMessage(
                        constructDeleteConfirmation(params, ()=>dispatch(replyDelete(params.postId, params.replyIndex, params.id, params.inFeed)))
                    )
                );
            }
            if(type == 'comment') {
                action['handler'] = () => dispatch(
                    addSystemMessage(
                        constructDeleteConfirmation(params, ()=>dispatch(replyCommentDelete(params.postId, params.replyId, params.replyIndex, params.id, params.inFeed)))
                    )
                );
            }
            if(type == 'booth') {
                action['handler'] = () => dispatch(
                    addSystemMessage(
                        constructDeleteConfirmation(params, ()=>dispatch(memoryDelete(params.id, params.inFeed)))
                    )
                );
            }
            if(type == 'boothComment') {
                action['handler'] = () => dispatch(
                    addSystemMessage(
                        constructDeleteConfirmation(params, ()=>dispatch(memoryCommentDelete(params.boothId, params.id, params.inFeed)))
                    )
                );
            }
        break;
        case 'share':
            action['handler'] = () => params.elemRef.share();
        break;
        case 'backend_url':
            if(type == 'question' || type == 'answer') {
                action['handler'] = () => {
                    if(params.adminUrl && typeof window != 'undefined') window.open(params.adminUrl);
                }
            }
        break;
        default:
    }
    return action;
}

const constructDeleteConfirmation = (params, confirmCallback) => {    
    return {
        id: Math.random(),
        message: params.t('community_action_delete_confirm'),
        level: 'warning',
        autoDismiss: 0,
        children: (
            <div>
                <button onClick={() => confirmCallback()}>
                    {params.t('onboarding_yes')}
                </button>
                <span> </span>
                <button>{params.t('onboarding_no')}</button>
            </div>
        )
    }    
}

export const buildMapping = (type='', actions=[], params, dispatch) => {
    const mapping = [];
    for(const i in actions) {
        mapping.push(mapAction(type, actions[i], params, dispatch));
    }
    return mapping;
}

///////////////////////////////////////////////////////////////
